import Reveal from "@/components/feature/Reveal";
import SectionHeading from "./SectionHeading";

const contactItems = [
  {
    icon: "ri-mail-send-line",
    title: "邮箱私信投稿",
    value: "editor@guatianbaoliao.com",
    desc: "适合需要来回确认细节的线索，可先只留临时邮箱。",
    href: "mailto:editor@guatianbaoliao.com",
    action: "发送邮件",
  },
  {
    icon: "ri-send-plane-line",
    title: "在线投稿入口",
    value: "填写线索表单",
    desc: "最快的方式，默认匿名提交，1 至 3 个工作日内完成初筛。",
    href: "#submit",
    action: "前往投稿",
  },
];

export default function Contact() {
  return (
    <section id="contact" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="联系我们"
            title="选择一种让你安心的联系方式"
            description="无论是补充线索、询问投稿进度，还是要求撤回已提交的内容，都可以通过下面的方式找到编辑。我们不会主动追问你的身份。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 md:mt-14 md:grid-cols-2">
          {contactItems.map((item, index) => (
            <Reveal key={item.title} delay={index * 90} className="h-full">
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-2xl text-primary-600 md:h-14 md:w-14">
                  <i className={item.icon} aria-hidden="true" />
                </span>
                <h3 className="mt-6 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 break-all font-label text-sm font-medium text-primary-600">{item.value}</p>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <a
                  href={item.href}
                  className="mt-6 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-background-100 px-5 py-3 text-sm font-medium text-secondary-800 transition-colors hover:bg-secondary-50 sm:w-auto"
                >
                  {item.action}
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-6 flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-6 md:flex-row md:items-center md:justify-between md:p-8">
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xl text-accent-700">
                <i className="ri-calendar-check-line" aria-hidden="true" />
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">编辑响应时间</h3>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                  周一至周五 10:00–19:00 由值班编辑查收；节假日顺延，通常 1 至 3 个工作日内给出回应。
                </p>
              </div>
            </div>
            <a
              href="#faq"
              className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              先看看常见问题
              <i className="ri-question-line" aria-hidden="true" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}